import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaSearch,
  FaEnvelope,
  FaCog,
  FaBars,
  FaHome,
  FaHashtag,
  FaBell,
  FaFileAlt,
  FaSignOutAlt,
  FaTimes,
} from "react-icons/fa";
import {
  AppBar,
  Toolbar,
  Avatar,
  Box,
  IconButton,
  Drawer,
  useMediaQuery,
  useTheme,
  InputBase,
  Badge,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import logo from "../../assets/images/logos/sconexlogo.png";
import kota from "../../assets/images/logos/kota-logo.png";
import Cookies from "js-cookie";
import kota2 from "../../assets/landingimages/Media.jpg";

import { useMaterialUIController } from "context";

const MainHeader = () => {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [profileImage, setProfileImage] = useState("https://via.placeholder.com/150");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchEmployeePhoto = async () => {
      if (user?.employeeId) {
        try {
          const response = await fetch(
            `http://185.193.19.156:8092/fintrack/getphoto/${user.employeeId}`,
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("hrms_token")}`,
              },
            }
          );

          if (response.ok) {
            const photoData = await response.blob();
            const imageUrl = URL.createObjectURL(photoData);
            setProfileImage(imageUrl);
          } else {
            setProfileImage("https://via.placeholder.com/150");
          }
        } catch (error) {
          console.error("Error fetching photo:", error);
          setProfileImage("https://via.placeholder.com/150");
        }
      }
    };

    fetchEmployeePhoto();
  }, []);

  const handleProfileClick = () => {
    if (user?.employeeId) {
      fetchEmployeePhoto();
    }
  };

  const fetchEmployeePhoto = async () => {
    if (user?.employeeId) {
      try {
        const response = await fetch(
          `http://185.193.19.156:8092/fintrack/getphoto/${user.employeeId}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("hrms_token")}`,
            },
          }
        );

        if (response.ok) {
          const photoData = await response.blob();
          const imageUrl = URL.createObjectURL(photoData);
          setProfileImage(imageUrl);
        } else {
          console.error("Failed to fetch photo");
        }
      } catch (error) {
        console.error("Error fetching photo:", error);
      }
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    Cookies.remove("access_token");
    Cookies.remove("hrms_token");
    Cookies.remove("jwt_token"); // Remove all authentication cookies

    navigate("/"); // Redirect user after logout
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#fff",
        backdropFilter: "blur(8px)",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        height: "80px",
        top: 0,
        left: 0,
        right: 0,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", height: "100%", gap: "20px" }}>
          <Box
            component="img"
            src={kota}
            alt="Brand Logo"
            onClick={() => navigate("/landing-page")}
            sx={{
              height: { xs: "40px", sm: "60px", md: "60px" }, // Increased height
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgba(14, 13, 13, 0.2)", // Transparent white

                borderRadius: "12px",
                padding: "6px 10px",
                mr: 2,
                width: "200px",
                border: "1px solid rgba(255, 255, 255, 0.3)", // Subtle border
              }}
            >
              <FaSearch style={{ color: "#666666", marginRight: "8px" }} />
              <InputBase
                placeholder="Search"
                sx={{
                  color: "#333333",
                  width: "100%",
                  fontSize: "14px",
                  "::placeholder": {
                    color: "#999",
                  },
                }}
              />
            </Box>
          )}

          <IconButton color="inherit">
            <Badge
              badgeContent={0}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#BA3511",
                  color: "#fff", // Ensures the text is visible
                },
              }}
            >
              <FaEnvelope />
            </Badge>
          </IconButton>

          <IconButton color="inherit">
            <FaCog />
          </IconButton>
          <IconButton color="inherit" onClick={toggleSidebar}>
            <FaBars />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer
        anchor="right"
        open={sidebarOpen}
        onClose={toggleSidebar}
        sx={{
          "& .MuiDrawer-paper": {
            width: 250,
            height: "100%",
            backgroundColor: "#333333",
            color: "#fff",
            padding: "0px",
            margin: "0px",
            border: "none",
            borderRadius: "0px",
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={toggleSidebar} sx={{ color: "#FFFFFF" }}>
              <FaTimes />
            </IconButton>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <IconButton onClick={handleProfileClick} sx={{ cursor: "pointer" }}>
              <Avatar src={profileImage} sx={{ width: 60, height: 60 }} />
            </IconButton>
            <Typography variant="h6" sx={{ mt: 1, color: "#FFFFFF" }}>
              {/* {user?.employeeName || ""} */}
              {(user?.employeeName || "").replace(/\s*null$/, "")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#CCFF99",
                fontWeight: "500",
                fontSize: { sm: "12px", md: "15px" },
              }}
            >
              {user?.employeeCode || ""}
            </Typography>
          </Box>

          <Divider sx={{ my: 2, bgcolor: "#FFFFFF" }} />
          <List>
            {[
              { icon: <FaHome />, text: "Home", onClick: () => navigate("/") },
              { icon: <FaHashtag />, text: "Explore" },
              { icon: <FaBell />, text: "Notifications" },
              { icon: <FaEnvelope />, text: "Messages" },
            ].map((item, index) => (
              <ListItem
                button
                key={index}
                onClick={item.onClick}
                sx={{
                  "&:hover": { backgroundColor: "#E59400" },
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                <ListItemIcon sx={{ color: "#FFFFFF", minWidth: "40px", fontSize: "18px" }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{ color: "#FFFFFF" }}
                  primaryTypographyProps={{
                    fontSize: "15px",
                  }}
                />
              </ListItem>
            ))}
          </List>
          <Divider sx={{ my: 2, bgcolor: "#FFFFFF" }} />
          <List>
            <ListItem
              button
              sx={{
                // "&:hover": { backgroundColor: "#E59400" },
                borderRadius: 0,
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              <ListItemIcon sx={{ color: "#FFFFFF", minWidth: "40px", fontSize: "18px" }}>
                <FaFileAlt />
              </ListItemIcon>
              <ListItemText
                primary="Terms & Conditions"
                sx={{ color: "#FFFFFF" }}
                primaryTypographyProps={{
                  fontSize: "15px",
                }}
              />
            </ListItem>
            {/* <ListItem
              button
              onClick={handleLogout}
              sx={{
                // "&:hover": { backgroundColor: "#E59400" },
                backgroundColor: "rgb(248, 248, 248)",
                borderRadius: "5px",
                padding: "10px",
                transition: "background-color 0.3s ease",
              }}
            >
              <ListItemIcon
                sx={{
                  color: "rgba(100, 92, 30, 0.93)",
                  minWidth: "40px",
                }}
              >
                <FaSignOutAlt style={{ fontSize: "18px" }} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "#ffffff",
                }}
              />
            </ListItem> */}
            <ListItem
              button
              onClick={handleLogout}
              sx={{
                backgroundColor: "#F8F8F8",
                borderRadius: "8px",
                padding: "12px",
                transition: "background-color 0.3s ease, padding 0.3s ease",
                "&:hover": {
                  backgroundColor: "#E59400",
                  paddingLeft: "16px", // Slight indentation instead of scaling
                },
                "&:active": {
                  backgroundColor: "#D68200",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "#644C1E",
                  minWidth: "40px",
                  transition: "color 0.3s ease",
                }}
              >
                <FaSignOutAlt style={{ fontSize: "20px" }} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#333",
                }}
              />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default MainHeader;
